import { SET_CONTROLLED_FILTERS_OPEN, SET_LOADER } from '../actions/actionTypes'

const initState = {
    isControlledFiltersOpen : {},
    loaderStatus: false
}

const controlledComponentsReducer = (state = initState, action) => {
    // , JSON.stringify(action)
    // console.log(action.info)
    switch(action.type){
        case SET_CONTROLLED_FILTERS_OPEN : return {
            ...state,
            isControlledFiltersOpen : action.data
        }
        case SET_LOADER : return {
            ...state,
            loaderStatus : action.status
        }
        default : return state
    }
};

export default controlledComponentsReducer;